import React, { useEffect, useState } from "react";
import { Col, Row, Container, Spinner } from "react-bootstrap";
import { LuRefreshCw } from "react-icons/lu";
import "./MainPage.css";
import TableComponent from "../Table/Table";
import CustomNavbar from "../Navbar/Navbar";
import ChartCheckbox from "./Tools/ChartCheckbox";
import axios from "axios";
import moment from "moment";
import DashChart from "./charts/DashChart";
import Footer from "../../Footer/Footer";
import Select from 'react-select'
import { useSelector } from 'react-redux';

function Dashboard() {

    const [summaryResult, setSummaryResult] = useState([]);
    const [affStats, setAffStats] = useState([]);
    const [promoStats, setPromoStats] = useState([]);
    const [chartStats, setChartStats] = useState([])
    const [summaryPeriode, setSummaryPeriode] = useState("0")
    const [topAffPeriode, setTopAffPeriode] = useState("0")
    const [topPromoPeriode, setTopPromoPeriode] = useState("0")
    const [chartPeriod, setChartPeriod] = useState("0")
    const [totalDeposit, setTotalDeposit] = useState([]);
    const [totalDepositAmounts, setTotalDepositAmount] = useState([])
    const [totalRegistrations, setTotalRegistrations] = useState([])
    const [totalViews, setTotalViews] = useState([]);
    const [totalClicks, setTotalClicks] = useState([]);
    const [totalDirectLinks, setTotalDirectLinks] = useState([])
    const [totalCommision, setTotalCommssions] = useState([])
    const [checkTotalDeposit, setCheckTotalDeposit] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loadingSummary, setLoadingSummary] = useState(false)
    const [loadingTopAff, setLoadingTopAff] = useState(false)
    const [loadingTopPromo, setLoadingTopPromo] = useState(false);
    const [hiddenChartLegend, setHiddenChartLegend] = useState([])
    const [affliate, setAffliate] = useState({});
    const [loadingChart, setloadingChart] = useState(false)
    const StoreUser = useSelector((state) => state.user);
    const [statsSummaryPermission, setStatsSummaryCommissionPermission] = useState(false)
    const [statsSummaryCPAPermission, setStatsSummaryCPAPermission] = useState(false)
    const [statsTopAffliatePermission, setTopAffliatePermisssion] = useState(false)
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    useEffect(() => {
        setStatsSummaryCommissionPermission(checkPermission(affliate, "statssummary_commission_amount"));
        setStatsSummaryCPAPermission(checkPermission(affliate, "statssummary_cpa"))
        setTopAffliatePermisssion(checkPermission(affliate, "topaff_commission_amount"))

    }, [affliate])
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])

    const handleSummaryChange = (event) => {
        setSummaryPeriode(event.value);
    };
    const handleAffStatsChange = (event) => {
        setTopAffPeriode(event.value);
    };
    const handlepromoChange = (event) => {
        setTopPromoPeriode(event.value);
    };
    const handleChartPeriodeChange = (event) => {
        setChartPeriod(event.value);
    }
    const columns = React.useMemo(
        () => [
            {
                Header: "Currency ",
                accessor: "currency", // accessor is the "key" in the data
            },
            {
                Header: "Views",
                accessor: "views",
            },
            {
                Header: "Clicks",
                accessor: "clicks",
            },
            {
                Header: "Direct links",
                accessor: "directlinks",
            },
            {
                Header: "Registrations",
                accessor: "registrations",
            },
            {
                Header: "Company profit (total)",
                accessor: "companyprofit",
            },
            {
                Header: "New depositors",
                accessor: "newdepositors",
            },
            {
                Header: "RS",
                accessor: "rs",
            },
            ...(statsSummaryCPAPermission
                ? [
                    {
                        Header: "CPA",
                        accessor: "cpa",
                    },
                ]
                : []),
            ...(statsSummaryPermission
                ? [
                    {
                        Header: "Commission amount",
                        accessor: "commission",
                    },
                ]
                : []),
        ],
        []
    );

    const columns2 = React.useMemo(
        () => [
            {
                Header: "Affiliate ID",
                accessor: "id", // accessor is the "key" in the data
            },
            {
                Header: "Views",
                accessor: "views",
            },
            {
                Header: "Clicks",
                accessor: "clicks",
            },
            {
                Header: "Direct links",
                accessor: "directlinks",
            },
            {
                Header: "Registrations",
                accessor: "registrations",
            },
            {
                Header: "New depositors",
                accessor: "newdepositors",
            },
            {
                Header: "Amount of deposits",
                accessor: "depositamount",
            },
            {
                Header: "Company profit (total)",
                accessor: "companyprofit",
            },
            ...(statsTopAffliatePermission
                ? [
                    {
                        Header: "Commission amount",
                        accessor: "commission",
                    },
                ]
                : []),
        ],
        []
    );



    const getSummaryResult = async () => {
        setLoadingSummary(true)
        const summaryResultResponse = await axios.get(window.__CFG.API + "reports/GetStatsSummary?period=" + summaryPeriode, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoadingSummary(false)
        if (summaryResultResponse.data.Error == null)
            setSummaryResult(summaryResultResponse.data.Result);
    }
    const getTopaff = async () => {
        setLoadingTopAff(true)

        const topAffResultResponse = await axios.get(window.__CFG.API + "reports/GetTopAffiliates?period=" + topAffPeriode, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoadingTopAff(false)
        if (topAffResultResponse.data.Error == null) {
            setAffStats(topAffResultResponse.data.Result);
        }
    }
    const getTopPromo = async () => {
        setLoadingTopPromo(true)
        const topPromoResponse = await axios.get(window.__CFG.API + "reports/GetTopPromoMaterials?period=" + topPromoPeriode, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoadingTopPromo(false)
        if (topPromoResponse.data.Error == null)
            setPromoStats(topPromoResponse.data.Result);
    }
    const getChartStatistic = async () => {
        setLoading(true)
        const chartResponse = await axios.get(window.__CFG.API + "reports/GetStatsChart?period=" + chartPeriod, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (chartResponse.data.Error == null) {

            var labels = chartResponse.data.Result.labels;
            const totalDeposit = []
            const totalDepositAmount = []
            const totalRegistrations = []
            const totalViews = []
            const totalClicks = []
            const totalDirectLinks = []
            const totalCommision = []
            for (var i = 0; i < labels.length; i++) {
                totalDeposit.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totaldeposits[i]]);
                totalDepositAmount.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totaldepositamounts[i]]);
                totalRegistrations.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totalregistrations[i]]);
                totalViews.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totalviews[i]]);
                totalClicks.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totalclicks[i]]);
                totalDirectLinks.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totaldirectlinks[i]]);
                totalCommision.push([moment(labels[i]).utc().valueOf(), chartResponse.data.Result.data.totalcommission[i]]);

            }
            setTotalDeposit(totalDeposit)
            setTotalDepositAmount(totalDepositAmount)
            setTotalRegistrations(totalRegistrations);
            setTotalViews(totalViews)
            setTotalClicks(totalClicks)
            setTotalDirectLinks(totalDirectLinks)
            setTotalCommssions(totalCommision)
            setLoading(false)

        }
        setLoading(false)

    }

    useEffect(() => {
        getSummaryResult()
    }, [summaryPeriode])
    useEffect(() => {
        getTopaff()
    }, [topAffPeriode])
    useEffect(() => {
        getTopPromo()
    }, [topPromoPeriode])
    useEffect(() => {
        getChartStatistic()
    }, [chartPeriod])

    const handleCheckboxChange = () => {
        setCheckTotalDeposit(!checkTotalDeposit);
        if (checkTotalDeposit == true) {
            setTotalDeposit([])
        }
    };
    const refreshStatistic = () => {
        getSummaryResult()
        getTopaff()
        getTopPromo()
        getChartStatistic()
    }
    const columns3 = React.useMemo(
        () => [
            {
                Header: "Media ID",
                accessor: "id", // accessor is the "key" in the data
            },
            {
                Header: "Preview",
                accessor: "media",
            },
            {
                Header: "Views",
                accessor: "views",
            },

            {
                Header: "Clicks",
                accessor: "clicks",
            },
            {
                Header: "Direct links",
                accessor: "directlinks",
            },
            {
                Header: "CTR,%",
                accessor: "ctr",
            },
            {
                Header: "Registrations",
                accessor: "registrations",
            },
            {
                Header: "Company profit (total)",
                accessor: "companyprofit",
            },
        ],
        []
    );
    const optionsCurrency = [{ label: "USD", value: 1 }]
    const ChartOptionsPeriods = [{ label: "Today", value: "0" }, { label: "Yesterday", value: "1" }, { label: "Current month", value: "2" }, { label: "Last month", value: "3" },]
    const summaryPeriodes = [{ label: "7 Days", value: "0" }, { label: "1 Month", value: "1" }, { label: "3 Month", value: "2" }, { label: "6 Month", value: "3" }, { label: "1 Year", value: "4" }]
    const selectedCurrencyValue=optionsCurrency.find(options=>options.value===1)
    return (
        <>
            <div>
                <div>
                    <CustomNavbar />
                </div>
                <div>
                    <div>
                        <Container>
                            <Row className="justify-content-between mt-4 mobile-dashboard" style={{ margin: "auto" }} >
                                <Col lg={2} md={3} sm={4} className="dash-stats-refsh">
                                    <div>
                                        <span className="fw-bold h3" style={{ fontSize: 17 }}>Stats Chart</span>
                                    </div>
                                    <div className="refresh-stats-mobile" style={{ cursor: "pointer", textAlign: "end", marginTop: 10 }} onClick={refreshStatistic} >
                                        <span style={{ color: "#000", fontSize: 11 }} className="fw-semibold  pe-2">Refresh Stastics</span>
                                        {loading ? (<><Spinner size="sm" style={{ fontSize: 5 }} /></>) : (
                                            <LuRefreshCw size={20} style={{ cursor: "pointer" }} />)}
                                    </div>
                                </Col>

                                <Col lg={5} md={3} sm={6}>
                                    <Container className="d-flex chart-select" style={{ justifyContent: "flex-end" }}>
                                        <div className="dashboard-select-periode">
                                            <Select options={ChartOptionsPeriods} onChange={handleChartPeriodeChange} placeholder=" period" />
                                        </div>
                                        <div style={{ marginLeft: 3 }} className="dashboard-select-periode">
                                            <Select options={optionsCurrency} placeholder=" currency" value={selectedCurrencyValue} />
                                        </div>
                                    </Container>
                                    <div className="refresh-stats-desktop" style={{ cursor: "pointer", textAlign: "end", marginTop: 10 }} onClick={refreshStatistic} >
                                        <span style={{ color: "#000" }} className="fw-semibold  pe-2">Refresh Stastics</span>
                                        {loading ? (<><Spinner size="sm" style={{ fontSize: 5 }} /></>) : (
                                            <LuRefreshCw size={28} style={{ cursor: "pointer" }} />)}
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </div>

                    {/* char section  */}
                    <div>
                        <div>
                            {/* <CustomChart/> */}
                            <div className="dash-chart-wrap">

                                <div className="dash-chart-col-2">
                                    <DashChart totaldeposits={totalDeposit} totaldepositamounts={totalDepositAmounts} totalregistrations={totalRegistrations} totalviews={totalViews} totalclicks={totalClicks} totaldirectlinks={totalDirectLinks} totalcommission={totalCommision} hiddenLengend={hiddenChartLegend} loading={loading} />
                                </div>

                            </div>
                        </div>
                        <div style={{ display: "flex" }} className="dash-chart-checkbox" >
                            <ChartCheckbox color="black" size="13px" initialChecked={true} label="New depositors" />
                            <ChartCheckbox color="#6d5555" size="13px" initialChecked={checkTotalDeposit} label="Deposits" onChange={handleCheckboxChange} />
                            <ChartCheckbox color="#808080" size="13px" initialChecked={false} label="Amount of deposits" />
                            <ChartCheckbox color="#ad3233" size="13px" initialChecked={true} label="Registrations" />
                            <ChartCheckbox color="#91ac3f" size="13px" initialChecked={false} label="Views" />
                            <ChartCheckbox color="#694e98" size="13px" initialChecked={true} label="Clicks" />
                            <ChartCheckbox color="#3d80ba" size="13px" initialChecked={false} label="Direct Links" />
                            <ChartCheckbox color="#c21e5f" size="13px" initialChecked={true} label="Profits" />
                            <ChartCheckbox color="#f58500" size="13px" initialChecked={false} label="Commission amount" />
                        </div>
                    </div>
                    <Container className="border-top-dashed">

                        <Row className="align-items-center justify-content-between mt-4" style={{ paddingBottom: 15 }}>
                            <Col lg={1} md={3} sm={4} className="d-flex align-items-center">
                                <span style={{ fontSize: 17 }} className="fw-bold h3 text-nowrap">Stats Summary</span>
                            </Col>
                            <Col lg={2} md={3} sm={4} className="d-flex align-items-center">
                                <div className="dashboard-select">
                                    <Select options={summaryPeriodes} onChange={handleSummaryChange} placeholder=" period" />
                                </div>
                                
                            </Col>
                        </Row>

                        <Row className="mt-1 row-aff-dash">
                            <div className="aff-dash-summary-table">
                                <TableComponent className columns={columns} data={summaryResult} hiddenPagination={true} loading={loadingSummary} />
                            </div>
                        </Row>

                        {/* 2nd Table */}

                        <Row className="align-items-center justify-content-between mt-1" style={{ paddingBottom: 15 }}>
                            <Col lg={1} md={3} sm={4} className="d-flex align-items-center">
                                <span style={{ fontSize: 17 }} className="fw-bold h3 text-nowrap">Top affiliates</span>
                            </Col>
                            <Col lg={4} md={3} sm={4} className="d-flex align-items-center " style={{ gap: 2 }}>
                                <div className="dashboard-select-periode">
                                    <Select options={summaryPeriodes} onChange={handleAffStatsChange} placeholder=" period" />
                                </div>
                                <div className="dashboard-select">
                                    <Select options={optionsCurrency} placeholder=" currency" value={selectedCurrencyValue} />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-1 row-aff-dash">
                            <div className="aff-dash-summary-table">

                                <TableComponent columns={columns2} data={affStats} hiddenPagination={true} loading={loadingTopAff} />
                            </div>
                        </Row>

                        {/* 2 Table */}

                        <Row className="align-items-center justify-content-between mt-1" style={{ paddingBottom: 15 }}>
                            <Col lg={1} md={3} sm={4} className="d-flex align-items-center">
                                <span style={{ fontSize: 17 }} className="fw-bold h3 text-nowrap">Top promo materials</span>
                            </Col>
                            <Col lg={4} md={3} sm={4} className="d-flex align-items-center " style={{ gap: 2 }}>
                                <div className="dashboard-select-periode">
                                    <Select options={summaryPeriodes} onChange={handlepromoChange} placeholder=" period" />

                                </div>
                                <div className="dashboard-select">
                                    <Select options={optionsCurrency} placeholder=" currency" value={selectedCurrencyValue} />

                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-1 row-aff-dash">
                            <div className="aff-dash-summary-table">
                                <TableComponent columns={columns3} data={promoStats} hiddenPagination={true} loading={loadingTopPromo} />
                            </div>
                        </Row>



                    </Container>
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </>
    );
}

export default Dashboard;
